<template>
  <div class="modal-container clearfix">
    <vxe-form
        ref="xForm"
        class="my-form2"
        title-align="right"
        :data="formData"
        :rules="formRules">
      <vxe-form-item title="税务机关" field="taxId" span="24">
        <template>
          <Select v-model="formData.taxId" :disabled="!isEdit">
            <Option v-for="(item,index) in taxList" :value="item.id" :key="index">{{ item.taxComp }}</Option>
          </Select>
        </template>
      </vxe-form-item>
      <vxe-form-item title="分局账号" field="taxExpertUserName" span="24">
        <template>
          <vxe-input v-model="formData.taxExpertUserName" placeholder="请输入分局账号" :disabled="!isEdit"></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="账号密码" field="password" span="24">
        <template>
          <vxe-input v-model="formData.password" type="password" placeholder="请输入账号密码"></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="确认密码" field="confirmPassword" span="24">
        <template>
          <vxe-input v-model="formData.confirmPassword" type="password" placeholder="请再次输入账号密码"></vxe-input>
        </template>
      </vxe-form-item>
    </vxe-form>
    <div class="modal-footer add-btn-box">
      <Button @click="close" style="width: 100px">取 消</Button>
      <Button type="primary" style="width: 100px" @click="commit">提 交</Button>
    </div>
  </div>
</template>
<script>
import md5 from "js-md5";
import $api from "@/apiProvider";
import {hideLoading, isEmpty, showLoading} from "@/utils/util";

export default {
  props: ['taxList'],
  data() {
    const confirmPwd = ({cellValue}) => {
      if (this.formData.confirmPassword !== this.formData.password) {
        return Promise.reject(new Error("两次密码输入不一致"));
      }
    };
    return {
      formData: {
        taxId: null,
        taxExpertUserName: null,
        password: null,
        confirmPassword: null,
      },
      isEdit: true,
      searchLoading: false,
      formRules: {
        taxId: [{required: true, message: "请选择税务机关"}],
        taxExpertUserName: [{required: true, message: "请输入分局账号"}],
        password: [{required: true, message: "请输入账号密码"}],
        confirmPassword: [{required: true, message: "请再次输入账号密码"}, {validator: confirmPwd}],
      }
    }
  },
  mounted() {
  },
  methods: {
    setUpdate(row) {
      this.formData = row;
      this.isEdit = false;
    },
    async validEvent() {
      let errMap = await this.$refs.xForm.validate().catch((errMap) => errMap);
      return errMap ? false : true;
    },
    async commit() {
      let sts = await this.validEvent();
      if (!sts) {
        return;
      }
      if (!this.formData.id) {
        this.create();
      } else {
        this.update();
      }
    },
    async create() {
      showLoading();
      let obj = Object.assign({}, this.formData)
      obj.password = md5(obj.password);
      let res = await $api.tax.post('createTaxUser', obj);
      hideLoading();
      if (res.status === 1) {
        this.$Message.success("添加成功");
        this.close();
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    async update() {
      showLoading();
      let obj = Object.assign({}, this.formData)
      obj.password = md5(obj.password);
      let res = await $api.tax.post('updateTaxUserPwd', obj);
      hideLoading();
      if (res.status === 1) {
        this.$Message.success("修改成功");
        this.close();
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    reset() {
      this.formData = {
        taxId: null,
        taxExpertUserName: null,
        password: null,
        confirmPassword: null,
      };
      this.isEdit = true;
    },
    close() {
      this.reset();
      this.$emit('close');
    },
  }
}
</script>
<style scoped>
.modal-footer {
  padding: 10px 0;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: flex-end;
  width: 96%;
  position: absolute;
  bottom: 0;
}
</style>